define("CartSEO.EntryPoint", ["Cart.Detailed.View"], function (
  CartDetailedView
) {
  "use strict";

  return {
    mountToApp: function mountToApp() {
      _.extend(CartDetailedView.prototype, {
        getAddToHead: function getAddToHead() {
          return '<meta name="robots" content="noindex, nofollow">';
        },
      });
    },
  };
});
